import { HELP_SEO_TITLE_MAX } from "@/features/help/help.static";

/**
 * `<title>` is "Question | Help Center | Whoppah". SEO appends " | Whoppah",
 * so this returns "Question | Help Center" and truncates the question when the
 * combined string would exceed the budget. The brand suffix is never trimmed.
 */
export const buildHelpDocumentTitle = (
  question: string,
  sectionLabel: string,
  maxLength = HELP_SEO_TITLE_MAX
): string => {
  const suffix = ` | ${sectionLabel}`;
  const budget = Math.max(16, maxLength - suffix.length);
  const trimmed = question.trim();

  if (trimmed.length <= budget) {
    return `${trimmed}${suffix}`;
  }

  return `${trimmed.slice(0, budget - 3).trimEnd()}...${suffix}`;
};

export const formatHelpUpdatedDate = (
  updatedAt: string,
  locale: string
): string => {
  const date = new Date(updatedAt);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return date.toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
